import Footer from "components/footer";
import React, { PropTypes, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ContentGrid from "components/contentGrid";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { IKContext } from "imagekitio-react";
import HeaderSection from "components/header/index.jsx";
import VideoSection from "components/bannerVideo";
import Moonshot from "components/moonshot";
import InteractiveContent from "components/wallofFrame";
import Creators from "components/creators";
import Whatsnew from "components/whatsNew";
import Footerform from "components/footerForm";

const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

export default function Application(props) {
  return (
    <IKContext urlEndpoint={IMAGE_CDN_ENDPOINT}>
      <HeaderSection />
      <VideoSection />
      <Moonshot/>
      <InteractiveContent />
      <Creators />
      <ContentGrid />
      <Whatsnew />
      <Footerform />
      <Footer />
    </IKContext>
  );
}
